import { HIPAAprops } from '@usacsmideo/types';

export const HIPAASectionText = (props: HIPAAprops) => {
  return <p className="my-2 text-sm font-semibold">{props.text}</p>;
};
